import store from 'Store';

export function scrollTo (element, smooth = true, addOffset = false) {
    const settings = {};
    if (smooth) {
        settings.behavior = 'smooth';
    }
    let offset = store.getters.getHeaderHeight;
    if (addOffset) {
        offset += 40;
    }
    const newScrollPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;

    settings.top = newScrollPosition;

    window.scrollTo(settings);
}
